import React from "react";
import { DonContext } from "../../pages/StandardDon";
import { Backdrop, Box, Button, Typography, CircularProgress } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { Context } from "../../App";


export default function RecapSection() {
    const navigate = useNavigate();
    const { isConnected, region } = React.useContext(Context);
    const { isAnonyme, recurrent, egliseNum, dime, off_global, offrandesFederale, offrandesLocale, total} = React.useContext(DonContext);
    const [load, setLoad] = React.useState(false);

    function handleSubmit() {
        setLoad(true);
        console.log("Processing add to cart for total:", total);
        fetch(process.env.REACT_APP_ESDRAS_API_URL.concat('/panier/add?model=Don'), {method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${isConnected ? localStorage.getItem('token') : localStorage.getItem('anonUserId') || ''}`
            }, 
            body: JSON.stringify({
                isAnonyme,
                user: isConnected ? localStorage.getItem('user') : localStorage.getItem('anonUserId'),
                recurrent,
                dime,
                offrande_globale: off_global,
                offrande_spe_feam: offrandesFederale.filter(off => off.montant > 0),
                offrande_spe_eglise: offrandesLocale.filter(off => off.montant > 0),
                eglise: Number(egliseNum),
                region
            })
        }).then(async (res) => {
            const token = res.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            if(res.ok) {
                const data = await res.json();
                return data;
            } else {
                const error = await res.text();
                throw new Error(`API error: ${res.status} - ${error}`);
            }
        }).then((data) => {
            console.log(" response:", data);
            setLoad(false);
            //redirect to cart
            navigate('/panier');
        }).catch((err) => {
            console.error("Error during add to cart:", err);
            setLoad(false);
        });
    }
    
    return <Box display={"flex"} flexDirection="column" gap={2} sx={{ mt: 2, mb:4, px: { xs: 2, sm: 0 } }}>
        <Typography variant="h1" component="h1" sx={{ fontSize: { xs: '1.75rem', sm: '2.5rem' } }}>Récapitulatif</Typography>

        <Typography variant="body1" align="center" gutterBottom sx={{ fontSize: { xs: '0.9rem', sm: '1rem' } }}>
            Vous vous appretez à ajouter le don suivant à votre panier :
        </Typography>

        <Typography variant="body1" sx={{ fontSize: { xs: '0.875rem', sm: '1rem' }, lineHeight: { xs: 1.4, sm: 1.6 } }}>
            Dime: {dime} €<br />
            Offrande globale: {off_global} €<br />
            Offrandes fédérales: {offrandesFederale.filter(off => off.montant > 0).map((off, index) => `${off.libelle}: ${off.montant} €`).join(', ')}<br />
            Offrandes locales: {offrandesLocale.filter(off => off.montant > 0).map((off, index) => `${off.libelle}: ${off.montant} €`).join(', ')}<br />
        </Typography>
      
        <Typography variant="h5" color='primary' sx={{fontWeight:'bold', marginBlock:2, marginLeft: { xs: 0, sm: 5 }, textAlign: { xs: 'center', sm: 'left' }, fontSize: { xs: '1.25rem', sm: '1.5rem' }}}>TOTAL DON: {total?.toFixed(2)}€</Typography> 

        <Button variant="contained" onClick={handleSubmit} disabled={total<=0} sx={{alignSelf:'center', px: { xs: 4, sm: 5 }, mb:2, fontSize: { xs: '0.875rem', sm: '1rem' }}}>Ajouter au panier</Button>

        <Backdrop open={load}><CircularProgress/></Backdrop>
    </Box>
}